var _g, _rect, _g2, _rect2, _rect3, _rect4, _g3, _rect5, _rect6, _rect7, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 122,
    viewBox: "0 0 161 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1294_13201)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 10,
    width: 122,
    height: 98,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.25,
    y: 10.25,
    width: 121.5,
    height: 97.5,
    rx: 5.75,
    stroke: "#EBEDF5",
    strokeWidth: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 20,
    width: 102,
    height: 24,
    rx: 4,
    fill: "white",
    stroke: "#D0D5EA",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1294_13201)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 26,
    width: 124,
    height: 30,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.1,
    y: 26.1,
    width: 123.8,
    height: 29.8,
    rx: 3.9,
    stroke: "#DDE3EC",
    strokeWidth: 0.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 35,
    width: 47.8066,
    height: 3.49805,
    rx: 1.16602,
    fill: "#E4E6EF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 43.1641,
    width: 33.8145,
    height: 3.49805,
    rx: 1.16602,
    fill: "#E4E6EF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 31,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#E4E6EF"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1294_13201)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 62,
    width: 112,
    height: 28,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1,
    y: 62.1,
    width: 111.8,
    height: 27.8,
    rx: 2.9,
    stroke: "#DDE3EC",
    strokeWidth: 0.2
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 70,
    width: 25.4375,
    height: 3.28227,
    rx: 1.64114,
    fill: "#E4E6EF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 77.6562,
    width: 30.737,
    height: 3.28227,
    rx: 1.64114,
    fill: "#E4E6EF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 66,
    width: 20,
    height: 20,
    rx: 2,
    fill: "#E4E6EF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126.711,
    cy: 82,
    r: 13,
    fill: "#E1E3EC",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.015 81.1758C130.652 81.5483 130.057 81.5564 129.684 81.1941L127.655 79.2196L127.655 87.0591C127.655 87.5787 127.234 88 126.714 88C126.194 88 125.773 87.5787 125.773 87.0591L125.773 79.1606L123.749 81.185C123.381 81.5524 122.785 81.5524 122.418 81.185C122.051 80.8176 122.051 80.2218 122.418 79.8544L125.997 76.2756C126.361 75.9117 126.949 75.9077 127.318 76.2665L130.996 79.8453C131.369 80.2077 131.377 80.8034 131.015 81.1758Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1294_13201",
    x: 15,
    y: 0,
    width: 146,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1294_13201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1294_13201",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1294_13201",
    x: 0,
    y: 20,
    width: 140,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1294_13201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1294_13201",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1294_13201",
    x: 35,
    y: 58,
    width: 124,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.137255 0 0 0 0 0.243137 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1294_13201"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1294_13201",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/FileUpload.cb92b21f250d78ddf42df2ce175ba56d.svg";
export { ForwardRef as ReactComponent };